import { loadStripe, type Stripe } from '@stripe/stripe-js'

/**
 * Stripe.js, cargado una vez para toda la aplicación.
 *
 * Compartido y no uno por componente: cada `loadStripe` inyecta otra etiqueta
 * de script, y con el pago embebido y el alta de tarjeta en pantallas distintas
 * eran dos cargas del mismo SDK. La promesa se memoriza, así que quien llegue
 * segundo recibe la misma instancia.
 */
let stripePromise: Promise<Stripe | null> | null = null


/** `null` cuando falta la clave pública — quien llame decide qué enseñar. */
export function getStripe(): Promise<Stripe | null> | null {
  const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined
  if (!key) return null
  stripePromise ??= loadStripe(key)
  return stripePromise
}
